module.exports = __webpack_public_path__ + "assets/CTA.2bfaff23.png";